// app/javascript/controllers/scroll_controller.js
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    enabled: Boolean,
    targetId: String
  }

  connect() {
    if (!this.enabledValue || !this.targetIdValue) return

    const el = document.getElementById(this.targetIdValue)

    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }
}